import React from 'react';
import Form from 'core/form/form';
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {FormProps, ClosedContentProps} from "core/form/formUtils";
import SyntheticEvent = React.SyntheticEvent;
import {DomainAncestor} from "core/common/domain/DomainAncestor";
import {DefinitionType} from "core/form/form";
import {ComponentClass} from "react";


export const fieldStyles = {
  small: {
    textField: {
      style: {
        fontSize: 14,
        height: 60,
        marginBottom: 2
      },
      floatingLabelStyle: {
        top: 27
      },
      hintStyle: {lineHeight: '24px'},
      inputStyle: {marginTop: 9},
      errorStyle: {top: -13}  // lepsi by bylo nastavit bottom, jenze v kodu TextField se bottom nastavuje natvrdo na fontSize + 3 = 15px, takze nastavime top a vyuzijme toho ze "When both top and bottom are specified, the top property takes precedence and the bottom property is ignored."
    },
    textArea: {
      style: {
        fontSize: 14,
        marginTop: -12
      },
      floatingLabelStyle: {},
      hintStyle: {lineHeight: '24px'},
      errorStyle: {top: -5}
    },
    styledSelect: {
      style: {
        fontSize: 14,
        height: 60,
        marginBottom: 2
      },
      floatingLabelStyle: {
        top: 27
      }
    },
    checkbox: {
      style: {
        paddingTop: 20
      },
      labelStyle: {
        fontSize: 14
      }
    },
    radioButton: {
      style: {
      },
      labelStyle: {
        fontSize: 14
      }
    },
    default: {
      style: {
        fontSize: 14,
        height: 60,
        marginBottom: 2
      },
      floatingLabelStyle: {
        top: 27
      }
    }
  },
  big: {
    textField: {
      style: {},
      floatingLabelStyle: {}
    },
    textArea: {
      style: {},
      floatingLabelStyle: {}
    },
    styledSelect: {
      style: {
        fontSize: 18,
        height: 60,
        marginBottom: 2
      },
      floatingLabelStyle: {}
    },
    checkbox: {
      style: {},
    },
    radioButton: {
      style: {},
    },
    default: {
      style: {},
      floatingLabelStyle: {}
    }
  },
  huge: {
    textField: {
      style: {
        fontSize: 26,
        height: 100,
        marginBottom: 4
      },
      floatingLabelStyle: {
        top: 37
      },
      hintStyle: {lineHeight: '34px'},
      inputStyle: {marginTop: 19},
      errorStyle: {top: -23}  // lepsi by bylo nastavit bottom, jenze v kodu TextField se bottom nastavuje natvrdo na fontSize + 3 = 15px, takze nastavime top a vyuzijme toho ze "When both top and bottom are specified, the top property takes precedence and the bottom property is ignored."
    },
    styledSelect: {
      style: {
        fontSize: 26,
        height: 100,
        marginBottom: 4
      },
      floatingLabelStyle: {
        top: 37
      },
      hintStyle: {lineHeight: '34px'},
      inputStyle: {marginTop: 19},
      errorStyle: {top: -23}
    },
  }
};



export function createForm<D extends DomainAncestor, R extends DomainAncestor>(definition: DefinitionType, ClosedContent: React.StatelessComponent<ClosedContentProps<D>>|React.ComponentClass<ClosedContentProps<D>> ): any {

  return function (FormComponent: any) {

    const hocFormClass = observer(class extends React.Component<FormProps<D, R>, any> {

      constructor(props) {
        super(props);
      }


      validate = () => {
        let {dataObject, rootObject} = this.props;
        let form = dataObject.getForm(definition.formName);

        rootObject.$errors = [];
        return  form.validateForm(dataObject, rootObject.$errors);
      };


      componentWillMount() {
        let {dataObject, rootObject, entity, entities, extractFieldFn} = this.props;
        //console.log('%c %s componentWillMount', 'background-color: magenta', definition.formName);

        let form: Form<D> = dataObject.getForm(definition.formName);

        form.initForm(entity, entities, dataObject, rootObject, extractFieldFn);

        form.updateAllFieldsPropValue(dataObject);

        //setDataAction(rootObject, 'createForm( + FormComponent.name + )#componentWillMount()');
      }

      componentWillReceiveProps(nextProps) {
        let {dataObject, rootObject, entity, entities, extractFieldFn} = nextProps;
        console.log('%c %s componentWillReceiveProps %O', 'background-color: magenta', definition.formName, nextProps);

        if (this.props.dataObject !== dataObject) {
          let form = dataObject.getForm(definition.formName);
          if (!form.fields) {
            form.initForm(entity, entities, dataObject, rootObject, extractFieldFn);
          }
          form.updateAllFieldsPropValue(dataObject);
        }

      }



      render() {
        return <FormComponent {...this.props} formName={definition.formName} form={this.props.dataObject.getForm(definition.formName)} validate={this.validate}/>;
      }


    });


    mdEntityService.setFormDefinition(definition.formName, definition);
    if (ClosedContent) {
      mdEntityService.setClosedContent(definition.formName, ClosedContent);
    }
    return hocFormClass;

  };

}





// WEBPACK FOOTER //
// ./src/core/form/createForm.tsx